<template>
  <v-container grid-list-md fluid class="pa-0">
    <v-card class="pa-2 card-r mb-2">
    <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
      <div class="text-xs-left f-17">Subscription</div>
    </v-toolbar>
    </v-card>
    <v-card class="pa-2 card-r mb-2 grey lighten-4">

    <v-layout>
            <v-flex>
                <v-data-table :headers="headers" :items="SubscriptionData" class=" card-r no-shadow">
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.packageName }}</td>
                        <td>{{ props.item.date }}</td>
                        <td>{{ props.item.cost }}</td>
                        <td>{{ props.item.dkk }}</td>
                        <td>{{ props.item.payment }}</td>
                        <td>
                          <v-dialog
                            v-model="dialog"
                            width="500">
                            <v-icon slot="activator">visibility</v-icon>
                            <v-card class="pa-2 card-r mb-2 grey lighten-4">
                              <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
                                <div class="text-xs-left f-20 text-capitalize">Invoice</div>
                                <v-spacer></v-spacer>
                                <v-btn class="mr-2 tow-clor-1" icon @click="dialog = false">
                                  <v-icon class="text-white f-28">close</v-icon>
                                </v-btn>
                              </v-toolbar>
                                  <v-layout row wrap class="pa-0">
                                    <v-flex d-flex lg12 sm12 xs12>
                                      <v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">
                                        <v-layout wrap xs12 class="pa-1 text-xs-left" >
                                          <v-flex xs12 class="pa-0">
                                            <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                              <v-layout row class="ma-0">
                                                <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Customer Name:-</p> </v-flex>
                                                <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">{{props.item.Customer_name}}</v-flex>
                                              </v-layout>
                                            <!--</v-card>-->
                                          </v-flex>
                                          <v-flex xs12 class="pa-0">
                                            <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                              <v-layout row class="ma-0">
                                                <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Address:-</p> </v-flex>
                                                <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">{{props.item.customer_address}}</v-flex>
                                              </v-layout>
                                            <!--</v-card>-->
                                          </v-flex>
                                          <v-flex xs12 class="pa-0">
                                            <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                              <v-layout row class="ma-0">
                                                <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Package Name:- </p> </v-flex>
                                                <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular"> {{ props.item.packageName }}</v-flex>
                                              </v-layout>
                                            <!--</v-card>-->
                                          </v-flex>
                                          <v-flex xs12 class="pa-0">
                                            <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                              <v-layout row class="ma-0">
                                                <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Subscription Number:- </p> </v-flex>
                                                <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular"> {{ props.item.subscription_id }}</v-flex>
                                              </v-layout>
                                            <!--</v-card>-->
                                          </v-flex>
                                          <v-flex xs12 class="pa-0">
                                            <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                              <v-layout row class="ma-0">
                                                <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Date:-</p> </v-flex>
                                                <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">{{ props.item.date }} </v-flex>
                                              </v-layout>
                                            <!--</v-card>-->
                                          </v-flex>
                                          <v-flex xs12 class="pa-0">
                                            <!--<v-card class="PersonalCards w-100 mt-2 pa-0  shadow-1 card-r">-->
                                              <v-layout row class="ma-0">
                                                <v-flex xs4 class="label pa-0 f-13 font-weight-regular"><p>Amount:-</p> </v-flex>
                                                <v-flex xs8 class="scroll-y text-xs-right word-break pa-0 f-13 font-weight-regular">DKK {{ props.item.cost }}</v-flex>
                                              </v-layout>
                                            <!--</v-card>-->
                                          </v-flex>

                                        </v-layout>

                                      </v-card>
                                    </v-flex>
                                  </v-layout>

                            </v-card>
                          </v-dialog>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>

        </v-layout>
    </v-card>
    </v-container>
</template>
<script>
/* eslint-disable */
export default {
  name:"Subscription",
  data:()=>({
    dialog:false,
    userData:'',
    headers: [
        { text: "Item Name", value: "name" },
        {text: "Date",value: "start_date"},
//        { text: "End Date", value: "endDate" },
        { text: "Amount(kr)", value: "cost" },
//        { text: "Country", value: "dkk" },
    ],
    SubscriptionData:[]
  }),
  created(){
    var studentId=this.$router.history.current.params.id
    Store.dispatch("Students/getSubscriptionInformation",{student_id:studentId})
    setTimeout(()=>{
      var SubscriptionData=Store.state.Students.subscription.Subscription
      for(var x=0;x<SubscriptionData.length;x++){
        var temp={
             packageName:SubscriptionData[x].packages.name,
             date:SubscriptionData[x].packages.created_at,
             cost:SubscriptionData[x].packages.cost,
             payment:SubscriptionData[x].payment,
  //           dkk:"dkk",
             subscription_id:SubscriptionData[x].id,
             Customer_name:SubscriptionData[x].student.name,
             customer_address:this.setAddress(SubscriptionData[x].student),
             invoice_link:SubscriptionData[x].invoice,
           }
           this.SubscriptionData.push(temp)
      }
        // this.SubscriptionData=Store.state.AdminProfile.Subscription
    },2500);
    this.userData=Store.state.user
  },
  methods:{
    addressNullCheck(address){
          if(address==null || address=="null"){
            return ""
          }else{
            return address
          }
      },
    setAddress(payload) {
      console.log("Address")
      console.log(payload)
      let address={
        street:'',
        streetNumber:'',
        floor:'',
        door:'',
        zipCode:'',
        city:'',
      }
      address.street = payload.street;
      address.streetNumber= payload.streetNumber;
      address.floor = payload.floor;
      address.door = payload.door;
      address.zipCode = payload.zipCode;
      address.city = payload.city;
      let oneLineAddress =
        this.addressNullCheck(payload.street) +
        " " +
        this.addressNullCheck(payload.streetNumber) +
        " " +
        this.addressNullCheck(payload.floor) +
        " " +
        this.addressNullCheck(payload.door) +
        " " +
        this.addressNullCheck(payload.zipCode) +
        " " +
        this.addressNullCheck(payload.city);

        address.oneLineAddress =oneLineAddress.trim()
      // this.address=this.address
        return address.oneLineAddress
    },
  }
}
</script>
<style>
  .invoice{
    width: 700px;

  }
  .invoice-logo{
    margin: auto;
    border: 3px solid white;
    width: 150px !important;
    height: 150px;
    border-radius: 50%;
    -webkit-box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    -moz-box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    box-shadow: 10px 10px 14px -2px rgba(173,173,173,1);
    background-color: transparent !important;
  }
  .layout-invoice-contant{
    font-size: 12px;
    font-weight: 600;
  }
  .layout-invoice-contant span{
    padding: 10px 0px 10px 0px;

  }
  .layout-invoice-contant .span{
    border: 1px solid #0097cf;
    padding-left: 25px;
    padding-right: 25px;

  }
  .invoice .v-dialog:not(.v-dialog--fullscreen){
    overflow: hidden;
  }



</style>



// WEBPACK FOOTER //
// src/components/profile/student/Packages.vue